module.exports = __webpack_public_path__ + "assets/img/proofread_1.be0dca60.png";